import React, { FC } from 'react'

interface Props {
  className?: string
}
const Line: FC<Props> = (props) => {
  return (
    <svg id="Layer_1" data-name="Layer 1" viewBox="0 0 41.67 41.67" {...props}>
      <defs>
        <style>{'.cls-1{fill:currentColor}'}</style>
      </defs>
      <path
        className="cls-1"
        d="M17.22 15.42a.79.79 0 00-.79.8v6a.79.79 0 00.79.8.8.8 0 00.8-.8v-6a.8.8 0 00-.8-.8zM14.9 21.45h-2.22v-5.23a.79.79 0 00-.79-.8.8.8 0 00-.8.8v6a.8.8 0 00.8.8h3a.8.8 0 00.8-.8.79.79 0 00-.79-.77zM24.48 15.42a.8.8 0 00-.8.8V20l-3.09-4.21a.79.79 0 00-.63-.32.69.69 0 00-.25 0 .8.8 0 00-.55.76v6a.8.8 0 00.8.8.79.79 0 00.79-.8v-3.72l3.09 4.21a.81.81 0 00.64.32.73.73 0 00.25 0 .8.8 0 00.55-.76v-6a.8.8 0 00-.8-.86zM30.15 17a.8.8 0 100-1.59h-3a.8.8 0 00-.8.8v6a.8.8 0 00.8.8h3a.8.8 0 100-1.59h-2.22V20h2.22a.8.8 0 000-1.6h-2.22V17z"
      />
      <path
        className="cls-1"
        d="M34.14 0H7.52A7.52 7.52 0 000 7.52v26.62a7.53 7.53 0 007.52 7.53h26.62a7.53 7.53 0 007.53-7.53V7.52A7.53 7.53 0 0034.14 0zm-1.38 26.58c-3.18 3.66-10.3 8.12-11.92 8.8s-1.38-.43-1.31-.81c0-.23.21-1.3.21-1.3a3 3 0 000-1.37c-.17-.43-.84-.65-1.33-.75C11.07 30.18 5.67 25.09 5.67 19c0-6.79 6.81-12.31 15.17-12.31S36 12.21 36 19a11 11 0 01-3.24 7.58z"
      />
    </svg>
  )
}

export default Line
